import React from 'react'
import { Modal, Stack } from '~/components/_layouts'
import { UserIcon } from '@heroicons/react/24/outline'
import moment from 'moment'

const EventInfoDialog = ({
  dialogEvent,
  showEventInfoDialog,
  toggleShowEventInfoDialog,
}) => {
  return (
    <Modal
      title={
        <Stack direction="row" spacing={2}>
          <UserIcon className="h-6 w-6" />
          {dialogEvent?.extendedProps?.name}
        </Stack>
      }
      variant="secondary"
      size="md"
      open={showEventInfoDialog}
      onClose={() => toggleShowEventInfoDialog()}
    >
      <p>
        <span className="!font-bold">Time:</span>{' '}
        {moment(dialogEvent?.start).format('LLL')}
      </p>
      {dialogEvent?.extendedProps?.joinUrl &&
        dialogEvent?.extendedProps?.status !== 'cancelled' &&
        dialogEvent?.extendedProps?.status !== 'completed' && (
          <p>
            <span className="!font-bold">Link:</span>{' '}
            <a
              href={dialogEvent.extendedProps.joinUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:underline"
            >
              Join Meeting
            </a>
          </p>
        )}
      {dialogEvent?.extendedProps?.class == 'CoachWorkshop' && (
        <>
          <p>
            <span className="!font-bold">Company:</span>{' '}
            {dialogEvent?.extendedProps?.company || 'N/A'}
          </p>
          <p>
            <span className="!font-bold">CSM:</span>{' '}
            {dialogEvent?.extendedProps?.csm || 'N/A'}
          </p>
        </>
      )}
    </Modal>
  )
}

export default EventInfoDialog
